// Keep facets drawer open after filter update
(function() {
  const STORAGE_KEY = 'facets_drawer_open';

  // On page load: if drawer was open before reload, reopen it
  document.addEventListener('DOMContentLoaded', function() {
    if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
      const drawer = document.getElementById('facets-drawer');
      if (drawer) {
        // Small delay to let the page fully render
        setTimeout(function() {
          drawer.open();
        }, 50);
      }
    }
  });

  // Before page reloads due to filter change: save drawer state
  document.addEventListener('click', function(e) {
    const drawer = document.getElementById('facets-drawer');
    if (!drawer) return;
    const isOpen = drawer.hasAttribute('open') || drawer.classList.contains('is-open') || drawer.getAttribute('aria-hidden') === 'false';
    if (isOpen) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    }
  }, true);

  // Also intercept form submissions from the facets
  document.addEventListener('submit', function(e) {
    const drawer = document.getElementById('facets-drawer');
    if (!drawer) return;
    const isOpen = drawer.hasAttribute('open') || drawer.classList.contains('is-open') || drawer.getAttribute('aria-hidden') === 'false';
    if (isOpen) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    }
  }, true);

  // Clear the flag when user manually closes the drawer
  document.addEventListener('click', function(e) {
    // Check if clicking a close button inside drawer
    const closeBtn = e.target.closest('[data-dialog-close], dialog-close-button, [is="dialog-close-button"]');
    if (closeBtn) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  });

  // Watch for URL changes triggered by facets-form (the auto-submit)
  const originalPushState = history.pushState;
  history.pushState = function() {
    const drawer = document.getElementById('facets-drawer');
    if (drawer) {
      const isOpen = drawer.hasAttribute('open') || drawer.classList.contains('is-open') || drawer.getAttribute('aria-hidden') === 'false';
      if (isOpen) {
        sessionStorage.setItem(STORAGE_KEY, 'true');
      }
    }
    return originalPushState.apply(this, arguments);
  };
})();
